




import { Component, Prop, Vue } from 'vue-property-decorator';
import { UnitSystem } from '@/interfaces/units';
import { perRoadStore } from '@/store/store';

const echarts = require('echarts');

@Component({
  components: {},
})
export default class PrHorizontalStrainMeDesignPlot extends Vue {
  @Prop() threshold!: number;

  @Prop() useTransferFunction!: boolean;

  @Prop({ default: 0 }) k1!: number;

  @Prop({ default: 0 }) k2!: number;

  @Prop({ default: 0 }) targetPercentile!: number;

  @Prop({ default: 0 }) id!: number;

  @Prop({ default: 0 }) externalKey!: number;

  @Prop() horizontalStrainValues!: number[];

  // @PropSync('alternative') alt!: ILccaAlternative;
  plotKeyInternal = 0;

  get plotKey() {
    return this.plotKeyInternal + this.externalKey;
  }

  get unitSystemIsImperial() {
    return perRoadStore.displayUnits === UnitSystem.Imperial;
  }

  sync() {
    this.$emit('sync');
  }

  mounted() {
    this.createPlot();
    this.updatePlot();
  }

  updated() {
    this.createPlot();
    this.updatePlot();
  }

  get plotId() {
    return `horizontal-strain-plot-${this.id}`;
  }

  chart: any = null;

  goodName = 'Acceptable Region';

  failName = 'Falure Region';

  threshName = 'Threshold';

  acceptable = 'AcceptableOverThreshold';

  createPlot() {
    if (this.chart === null) {
      const el = document.getElementById(this.plotId);
      this.chart = echarts.init(el );
    } else {
      this.chart.dispose();
      this.chart = null;
      const el = document.getElementById(this.plotId);
      this.chart = echarts.init(el );
    }

    this.chart.setOption(
      {
        grid: {
          top: 5,
          right: 5,
          bottom: 45,
          left: 45,
          show: true,
          borderWidth: 1,
          borderColor: '#000',
        },
        tooltip: {},
        graphic: {
          elements: [
            {
              type: 'text',
              position: [120, 40],
              style: {
                text: 'Region of\nno damage',
                textAlign: 'center',
              },

            },
          ],
        },
        // legend: {
        //   type: 'plain',
        //   data: [
        //     {
        //       name: this.threshName,
        //     },
        //     {
        //       name: this.goodName,
        //     },
        //     {
        //       name: this.failName,
        //     },
        //   ],
        //
        // },
        xAxis: {
          scale: false,
          min: 0,
          max: 300,
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: true,
          },
          axisLine: {
            show: false,
          },
          name: 'μStrain (Tension)',
          nameLocation: 'middle',
          nameGap: 30,
        },
        yAxis: {
          name: 'Cumulative %',
          nameLocation: 'middle',
          nameGap: 30,
          min: 0,
          max: 100,
          axisLabel: {
            show: true,
            // formatter: ,
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            location: 'left',
            show: true,
            alignWithLabel: true,
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: 'line',
            name: this.threshName,
            data: null,
            animation: false,
            symbol: 'none',
            tooltip: {
              trigger: 'axis',
              formatter(obj: any) {
                return `<div>${obj[0].seriesName}:<br> ${obj[0].value[0].toFixed(0)} μStrain</div>`;
              },
            },
          },
          {
            type: 'line',
            name: this.goodName,
            symbol: 'none',
            data: null,
            tooltip: {
              formatter(obj: any) {
                return `<div>${obj[0].seriesName}:<br> ${obj[0].value[0].toFixed(0)} μStrain</div>`;
              },
            },
            lineStyle: {
              width: 0,
            },
            areaStyle: {
              origin: 'end',
              color: 'blue',
              opacity: 0.1,
            },
            animation: false,
          },
          {
            type: 'line',
            name: this.failName,
            symbol: 'none',
            data: null,
            lineStyle: {
              width: 0,
            },
            itemStyle: {
              color: 'red',
              opacity: 0.3,
            },
            areaStyle: {
              origin: 'end',
              color: 'red',
              opacity: 0.3,
            },
            animation: false,
          },
          {
            type: 'line',
            name: this.acceptable,
            data: null,
            symbol: 'none',
            lineStyle: {
              width: 0,
            },
            areaStyle: {
              color: '#FFFF00',
              origin: 'end',
              opacity: 0.3,
            },
          },

          {
            type: 'line',
            name: 'values',
            animation: false,
            symbol: 'none',
            lineStyle: {
              color: 'black',
            },
          },
          {
            type: 'line',
            name: 'Target Percentile',
            animation: false,
            symbol: 'none',
            lineStyle: {
              color: 'black',
            },
          },

        ],
      },
    );
  }


  updatePlot() {
    // console.log(this.threshold);
    // The acceptable region for strain responses
    // const thresholdLine = [
    //   [this.threshold, 0],
    //   [this.threshold, 100],
    // ];
    //
    // // The failure region for strain responses
    // const failArea = [
    //   [-300, 0],
    //   [this.threshold, 0],
    // ];
    //
    // // Boundary line
    // const goodArea = [
    //   [this.threshold, 0],
    //   [0, 0],
    // ];


    /*
    Series to plot if transfer function is being used
     */
    const thresholdLineTransferFcn = [
      [this.threshold, 0],
      [this.threshold, 100],
    ];

    // The failure region for strain responses
    const failAreaTransferFcn = [
      [this.threshold, 0],
      [300, 0],
    ];

    const goodAreaTransferFcn = [
      [0, 0],
      [this.threshold, 0],
    ];

    /*
    Series to plot if threshold only
     */
    
    const thresholdLine = [
      [this.threshold, 0],
      [this.threshold, this.targetPercentile],
      [300, this.targetPercentile],
    ];

    // The failure region for strain responses
    const failArea = [
      [this.threshold, 0],
      [this.threshold, this.targetPercentile],
      [300, this.targetPercentile],
    ];

    const goodArea = [
      [0, 0],
      [this.threshold, 0],
      [this.threshold, this.targetPercentile],
      // [300, this.targetPercentile],
    ];
    
    const acceptableArea = [
      [this.threshold, this.targetPercentile],
      [300, this.targetPercentile],
      // [this.threshold, 100],
      
    ];

    const series = [];

    if (!this.useTransferFunction) {
      // Plot the allowed regions for the strain response

      series.push({
        name: this.threshName,
        data: thresholdLine,
      });
      series.push({
        name: this.failName,
        data: failArea,
        areaStyle: {
          origin: 'start',
        },
      });
      series.push({
        name: this.goodName,
        data: goodArea,
      });
      series.push({
        name: this.acceptable,
        data: acceptableArea,
      });
    } else {
      // Plot the threshold whole-height
      series.push({
        name: this.threshName,
        data: thresholdLineTransferFcn,
      });
      series.push({
        name: this.failName,
        data: failAreaTransferFcn,
      });
      series.push({
        name: this.goodName,
        data: goodAreaTransferFcn,
      });
    }


    if (this.horizontalStrainValues) {
      const sortedValues = this.horizontalStrainValues.sort((a, b) => b - a);
      const cumulativePct = sortedValues.map((v, i) => i / sortedValues.length);

      const data = sortedValues.map((v, i) => [v * 1000000, (1 - cumulativePct[i]) * 100]);
      series.push({
        name: 'values',
        data,
      });
    }

    this.chart.setOption({
      series,
    });
  }
}
